import localConfig from './apiConfigLocal';
import devConfig from './apiConfigDev';
import prodConfig from './apiConfigProd';
import pocConfig from './apiConfigPoc';

var env
if (process.env.REACT_APP_LOCAL_DEV === 'local'){
  env = 'local';
}else{
  env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'local';
}

console.log('Environment:', env);

const configMap = {
  local: localConfig,
  development: devConfig,
  production: prodConfig,
  // AgentCore front-door PoC. Separate from `development` so that enabling the
  // front door cannot affect what the dev pipeline ships to dev.iq.pay.tnsi.com.
  poc: pocConfig
};

const config = configMap[env] || localConfig;

console.log('Selected config:', config);

export default config;
